import { getPath } from './Utils.js'
import Resource from './Resource.js'

export default class Resources {
  constructor( api, addRsrc = true ) {
    if ( addRsrc ) {
      this.api = api.child( 'rsrc' )
    } else {
      this.api = api
    }
  }

  create( path, data, opts ) {
    let nOpts = null, body = data, contentType = opts?.type || 'application/json'
    if ( opts ) {
      nOpts = { ...opts }
      delete nOpts.type
      delete nOpts.header
    }
    if ( opts?.header ) {
      // header and file
      if ( contentType !== 'application/json' ) {
        contentType = null
        body = new FormData()
        body.append( 'data', new Blob( [ data ], { type : opts.type } ) )
        body.append( 'header', JSON.stringify( opts.header ) )
      // json with header
      } else {
        body = {
          type : 'rsrcManager.Create',
          data,
          header : opts.header,
        }
      }
    }
    return this.api.child( getPath( path ) ).post( body, nOpts, { headers : { contentType } } )
  }

  get( resourceOrPath, opts ) {
    return this.api.child( getPath( resourceOrPath ) ).get( opts )
  }

  update( resourceOrPath, patch, file = null, opts ) {
    if ( file ) {
      const fd = new FormData()
      fd.append( 'patch', patch )
      fd.append( 'data', file )
      return this.api.child( getPath( resourceOrPath ) ).patchRaw( fd, opts, { headers : { contentType : null } } )
    }
    return this.api.child( getPath( resourceOrPath ) ).patch( patch, opts )
  }

  delete( resourceOrPath, opts ) {
    return this.api.child( getPath( resourceOrPath ) ).delete( null, opts )
  }

  list( resourceOrPath, opts ) {
    let nResourceOrPath = resourceOrPath, nOpts = opts
    if ( resourceOrPath != null && typeof resourceOrPath === 'object' && resourceOrPath.path == null ) {
      nResourceOrPath = null
      nOpts = resourceOrPath
    }
    return this.api.child( getPath( nResourceOrPath ) ).get( { ...nOpts, children : true } )
  }

  resource( resourceOrPath ) {
    return new Resource( this.api, resourceOrPath, false )
  }

}
